import {
  reverb_search_Filter,
  reverb_search_ListingsSearchRequest_Aggregation,
} from '../schemas/rql';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';
import { renameParams } from '@reverbdotcom/commons/src/facet_utils';
import { isBrandPage, isShopPage } from '@reverbdotcom/commons/src/url_helpers';
import { IUser } from '@reverbdotcom/commons';
import { Location } from 'history';
import { renameRqlParam } from './shared/rql_param_helper';

// Given an array of all listing filters from a graphql query,
// returns only relevant filters (and filter options) to display,
// based on the current user (experiment groups) and URL (brand page, shop page, marketplace, CSP).
export function listingsFilters(
  filters: reverb_search_Filter[],
  user: Partial<IUser>,
  location: Location,
): reverb_search_Filter[] {

  // Removes TRAITS filter if user isn't rolled out.
  if (!isExperimentEnabled(user, experiments.TRAIT_FACETS)) {
    filters = filters.filter(f =>
      f.aggregationName !== reverb_search_ListingsSearchRequest_Aggregation.TRAITS);
  }

  // Removes the 'combined_shipping' option from the
  // `Show Only` || `Find a Deal` filter if not viewing a shop page
  if (!isShopPage(location)) {
    filters = filters.map((filter) => {
      if (filter.key !== 'SHOW_ONLY' && filter.key !== 'FIND_A_DEAL') {
        return filter;
      }

      return {
        ...filter,
        options: filter.options.filter((o) => o.paramName !== 'combined_shipping'),
      };
    });
  }

  // Removes the sidebar keyword search when viewing a brand page
  if (isBrandPage(location)) {
    filters = filters.filter(filter => filter.key !== 'TEXT_QUERY');
  }

  return renameParams(filters, renameRqlParam);
}
